// extracted by mini-css-extract-plugin
module.exports = {"Deactivated":"pWxE-C9BF50vuU99YJsWf","ListItemVariant":"Bkt9HVirR9N5TSf83mYGO"};